import moment from 'moment-timezone'

function nFormatter(num, digits) {
  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ]
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
  var item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value
    })
  return item
    ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol
    : '0'
}

// Angka besar dipisah tiap ribuan dengan titik, mengikuti penulisan Indonesia
// (52469 -> 52.469).
function formatNumber(value) {
  const number = Number(value)
  if (!Number.isFinite(number)) {
    return '-'
  }
  return new Intl.NumberFormat('id-ID').format(number)
}

function formatCurrency(value) {
  return 'Rp ' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

function statusToText(data) {
  if (data.korwilApproval === false) {
    return 'Ditolak'
  }
  if (data.centralApproval === true) {
    return 'Disetujui'
  }
  if (data.korwilApproval === true && !data.centralApproval) {
    return 'Verif oleh Korwil'
  }
  // Server menandai "menunggu verifikasi" hanya dari korwilApproval. Produksi
  // punya baris dengan centralApproval = false (sisa approve lalu unapprove
  // lalu unverify); kalau di sini disyaratkan null, baris itu ikut terambil
  // filternya tapi tidak dapat badge sama sekali.
  if (data.korwilApproval === null && data.centralApproval !== true) {
    return 'Belum verifikasi'
  }
  return ''
}

// Nama dari form pendaftaran datang campur aduk: ada yang KAPITAL SEMUA, ada
// yang huruf kecil semua. Ditampilkan seragam sebagai Title Case.
// Pemisah kata ikut spasi, tanda hubung, apostrof, dan titik, supaya
// "M.fahmi al-rasyid" jadi "M.Fahmi Al-Rasyid".
function toTitleCase(value) {
  if (!value || typeof value !== 'string') {
    return value
  }
  return value
    .toLowerCase()
    .replace(
      /(^|[\s\-'.])(\S)/g,
      (_, separator, char) => separator + char.toUpperCase(),
    )
}

function masaBerlaku(data) {
  const validAt = data?.user?.validAt
    ? moment(data?.user?.validAt).tz('Asia/Jakarta').format('D/M/YYYY')
    : ''
  const expiredAt = data?.user?.expiredAt
    ? moment(data?.user?.expiredAt).tz('Asia/Jakarta').format('D/M/YYYY')
    : ''
  return validAt + ' - ' + expiredAt
}

function getFileName(fullPath) {
  var startIndex =
    fullPath.indexOf('\\') >= 0
      ? fullPath.lastIndexOf('\\')
      : fullPath.lastIndexOf('/')
  var filename = fullPath.substring(startIndex)
  if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
    filename = filename.substring(1)
  }
  return filename
}

export {
  nFormatter,
  formatNumber,
  formatCurrency,
  statusToText,
  masaBerlaku,
  getFileName,
  toTitleCase,
}
